import { render, staticRenderFns } from "./LiquidacionProductoComponent.vue?vue&type=template&id=372db89d&"
import script from "./LiquidacionProductoComponent.vue?vue&type=script&lang=js&"
export * from "./LiquidacionProductoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports